import { SuperAdminConstants } from '../../../_constants';

const initialState = { editSwotTextLoading: true, data: '', error: false };

export function editSwotTextReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_EDIT_SWOT_TEXT:
            return {
                editSwotTextLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_EDIT_SWOT_TEXT:
            return {
                editSwotTextLoading: false,
                data: action.editSwotText,
                error: false
            };
        case SuperAdminConstants.EDIT_SWOT_TEXT_ERROR:
            return {
                editSwotTextLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/SwotText/editSwotText.reducer.js